import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { Configuracao } from '../../models/configuracoes/configuracao';

@Injectable({
  providedIn: 'root'
})

export class ConfiguracaoService {
  private baseUrl: string;
  private headers = new HttpHeaders();

  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  public add(configuracao: Configuracao): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "configuracao": configuracao
    };

    return this.http.post<boolean>(this.baseUrl + "api/Configuracao/Add", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public forcarAtualizacaoPrecosVendedores(): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + "api/Configuracao/ForcarAtualizacaoPrecosVendedores", {
      usuarioId: Number(localStorage.getItem("id"))
    }, { headers: new HttpHeaders({
      'X-Login-Diario': localStorage.getItem('login_diario_token') || '',
      'X-Skip-Loader': 'true'
    }) });
  }

  public getByGuidClienteNapis(): Observable<Configuracao> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "guidclientenapis": localStorage.getItem("guidclientenapis")
    };

    return this.http.post<Configuracao>(this.baseUrl + "api/Configuracao/GetByGuidClienteNapis", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(null);
      })
    );
  }

  public update(configuracao: Configuracao): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "configuracao": configuracao
    };

    return this.http.post<boolean>(this.baseUrl + "api/Configuracao/Update", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }
}
